
const app = {
  state: {
    logRecord: {},
    layoutAlive: true
  },
  mutations: {
    LOG_RECORD: (state, data) => {
      if(typeof data != 'object' || data == null)
        return new Error('请传入Object数据类型！');
      state.logRecord = {...{LOG_VISI: true}, ...data};
    },
    TOGGLE_LAYOUTALIVE: (state) => {
      state.layoutAlive = false;
      setTimeout(() => {
        state.layoutAlive = true;
      }, 200)
    }
  },
  actions: {
    ReloadPage({commit}){
      commit('TOGGLE_LAYOUTALIVE');
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js